<template>
  <v-text-field
    v-model="fieldValue"
    :label="labelValue"
    validate-on-blur
    :rules="[validateRequired, validatePassword]"
    :type="fieldType"
    outlined
    :append-icon="icon"
    @click:append="appendedIconClick"
  ></v-text-field>
</template>

<script>
import { isValidPassword } from '@/lib/formValidations'

export default {
  props: [
    'value',
    'label',
    'rules',
    'isRequired',
    'isNeededToValidate'
  ],
  data () {
    return {
      fieldType: 'password',
      icon: 'visibility'
    }
  },
  computed: {
    fieldValue: {
      get () {
        return this.value
      },
      set (newValue) {
        this.$emit('valueChange', newValue)
      }
    },
    labelValue () {
      return this.label ? this.label : 'New Password'
    }
  },
  methods: {
    required (value) {
      return value ? true : `${this.labelValue} is required`
    },
    isValidPassword,
    validateRequired () {
      return this.isRequired ? this.required(this.fieldValue) : true
    },
    validatePassword () {
      return this.isNeededToValidate ? isValidPassword(this.fieldValue) : true
    },
    appendedIconClick () {
      this.fieldType = this.fieldType === 'password' ? null : 'password'
      this.icon = this.icon === 'visibility' ? 'visibility_off' : 'visibility'
    },
    reset () {
      this.fieldType = 'password'
      this.icon = 'visibility'
    }
  },
  mounted () {
    this.reset()
  }
}
</script>
